<template>
	<v-app id="inspire">
		<v-main>
			<server-down v-if="serverdown"></server-down>
			<slot name="content" v-else></slot>
			<material-dialog></material-dialog>
		</v-main>
		<!-- snackbar -->
		<v-snackbar :timeout="snackbarDuration" :color="snackbarColor" top v-model="showSnackbar">
			{{ snackbarMessage }}
		</v-snackbar>
	</v-app>
</template>

<script>
export default {
	data: () => ({}),
	props: {},
	computed: {
		//serverdown
		serverdown() {
			return this.$store.getters.serverdownmessage != null;
		},
		//snackbar
		showSnackbar: {
			get() {
				return this.$store.getters.showSnackbar;
			},
			set(val) {
				if (!val) this.$store.commit("hideSnackbar");
			},
		},
		snackbarMessage() {
			return this.$store.getters.snackbarMessage;
		},
		snackbarColor() {
			return this.$store.getters.snackbarColor;
		},
		snackbarDuration() {
			return this.$store.getters.snackbarDuration;
		},
	},
	methods: {},
};
</script>
